export default "__VITE_ASSET__CgaYdS6p__"